import { createFileRoute, Outlet } from '@tanstack/react-router'

// No guard here: the list and the documents need sales.read, the new-document page its own
// create access (CREATE_ACCESS), so a clerk who may create but not read sales can still create.
export const Route = createFileRoute('/_app/credit-notes')({
  staticData: { crumb: 'creditNotes' },
  component: Outlet,
})
